import { Check, Zap, Shield, Globe, Rocket, Activity, Cpu, BarChart3, Sparkles } from "lucide-react";

const ICONS = [Check, Zap, Shield, Globe, Rocket, Activity, Cpu, BarChart3, Sparkles];
const GRADIENTS = [
  "icon-tile-teal",
  "icon-tile-indigo",
  "icon-tile-blue",
  "icon-tile-orange",
  "icon-tile-pink",
  "icon-tile-green",
];

type Item = string | { title: string; description?: string };

const SolutionsGrid = ({ items }: { items: Item[] }) => (
  <div className="mx-auto mt-[32px] grid max-w-[1080px] grid-cols-1 gap-5 md:grid-cols-2 items-stretch">
    {items.map((raw, i) => {
      const item = typeof raw === "string" ? { title: raw } : raw;
      const Icon = ICONS[i % ICONS.length];
      const gradient = GRADIENTS[i % GRADIENTS.length];
      const isLast = i === items.length - 1;
      const isOddLast = isLast && items.length % 2 === 1;
      return (
        <article
          key={item.title}
          className={`flex items-start gap-4 rounded-[16px] border border-border/60 bg-white p-6 shadow-[0_2px_10px_rgba(15,22,35,0.04)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(15,22,35,0.08)] h-full ${
            isOddLast ? "md:col-span-2 md:mx-auto md:w-1/2" : ""
          }`}
        >
          <span
            className={`flex h-12 w-12 flex-none items-center justify-center rounded-[12px] ${gradient}`}
            aria-hidden="true"
          >
            <Icon className="h-6 w-6" strokeWidth={2.4} />
          </span>
          <div className="min-w-0 flex-1">
            <h3 className="text-[15.5px] font-bold leading-[1.35] text-foreground">
              {item.title}
            </h3>
            {item.description ? (
              <p className="mt-2 text-[13.5px] leading-[1.55] text-muted-foreground">{item.description}</p>
            ) : null}
          </div>
        </article>
      );
    })}
  </div>
);

export default SolutionsGrid;